module.exports = __webpack_public_path__ + "static/media/hashtags-image.b1b6dd8c.png";